import React from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'

export default function ExternalDeviceIndicator() {
  return (
    <div className="tc f4-ns dark-gray">
      <div className="image-wrapper relative mb6">
        <Icon type="scanIndicator" />
      </div>
      <div className="lh-copy">
        <FormattedMessage id="useBarcodeReader" />
        <br />
        <FormattedMessage id="barcodeToAddProducts" />
      </div>
    </div>
  )
}
